<template>
	<div class="wechat-system">
		<section class="wechat-system__card">
				<h1>微信公众号/ 小程序接入</h1>
				<div v-for="(item,index) in chat_types" :key="index">
					<span class="iconfont" :class="item.icon"></span>
					<div>
						<h4>{{item.title}}</h4>
						<p>{{item.desc}} <a :href="item.link" target="_blank" v-show="item.type == 2">查看帮助文档</a></p>
						<div class="more-text">
							<p v-show="item.type == 1">使用<span href="javascript:;">开发者授权模式</span>
							绑定后，之前在公众平台设置好的菜单和自动回复功能将失效，你需要在OCS+重新设置。</p></p>
							<a :href="item.link" target="_blank" v-show="item.type == 1">查看帮助文档</a>
						</div>
						
					</div>
					<el-popover width="260" v-model="item.visible" placement="left" trigger="click">
						  <el-radio-group v-model="bindType" class="radio-wechat">
								<el-radio label="1">第三方平台授权(推荐)</el-radio>
								<el-radio label="2">开发者授权(安全模式)</el-radio>
						   </el-radio-group>
						  <div style="text-align: right; margin: 5px 0">
							<el-button size="mini" type="text" @click="item.visible = false">取消</el-button>
							<el-button type="primary" size="mini" @click.stop="onBindAdd(item)">确定</el-button>
						  </div>
					   <el-button slot="reference" type="primary" icon="el-icon-plus" plain size="small">{{item.btn}}</el-button>
					</el-popover>
					
				</div>
			</section>
		<section class="wechat-system__table">
			<h1>已绑定列表</h1>
			<table-pagination v-loading="loading" ref="tableItem" pagination layout="prev,pager,next,total" :data="data"
				:column="column" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
				@pagination="getList">
				<template v-slot:action="{row}">
					<!-- <el-button type="text" size="small" @click="onBindCopy(row)" v-show="row.status == 1">开发者管理</el-button> -->
					<!-- <el-divider direction="vertical" v-if="row.status == 1"></el-divider> -->
					<el-button type="text" size="small" @click="onBasic(row)" :disabled="row.status == 2">基础设置</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button type="text" size="small" @click="onAdvanced(row)" :disabled="row.status == 2">高级配置</el-button>
				</template>
				<template v-slot:appid="{row}">
					<el-button v-if="row.status == 1" type="text" @click="onDetail(row)">{{row.appid}}</el-button>
					<el-popover width="260" placement="left" trigger="hover">
						  <el-radio-group v-model="bindType" class="radio-wechat">
								<el-radio label="1">公众号第三方平台授权(推荐)</el-radio>
								<el-radio label="2">公众号开发者授权</el-radio>
						   </el-radio-group>
						  <div style="text-align: right; margin: 5px 0">
							<el-button type="primary" size="mini" @click="onBind(row)">确定</el-button>
						  </div>
					   <el-button slot="reference" type="text" size="small" v-show="row.status!=1">授权</el-button>
					</el-popover>
					<!-- <el-button v-else type="text" size="small">授权</el-button> -->
				</template>
			</table-pagination>
		</section>
		<!-- 绑定小程序/公众号 -->
		<bindWechat ref="bindWechat" @getList="getList"></bindWechat>
		<!-- 基础设置 -->
		<setBasic ref="setBasic" @getList="getList"></setBasic>
		<!-- 高级配置 -->
		<setAdvanced ref="setAdvanced"></setAdvanced>
		<!-- 开放平台模式详情 -->
		<openTypePlatform ref="openTypePlatform"></openTypePlatform>
	</div>
</template>

<script>
	import bindWechat from './bindWechat'
	import setBasic from './setBasic.vue'
	import setAdvanced from './setAdvanced.vue'
	import setEvents from './setEvents.vue'
	import openTypePlatform from './openTypePlatform.vue'
	import {messageHandleTypeObj,messageHandleStatus,chat_type} from '../data.js'
	export default {
		components:{
			bindWechat,
			setBasic,
			setAdvanced,
			setEvents,
			openTypePlatform
		},
		data() {
			return {
				chat_types:chat_type,
				bindType:'1',//绑定方式 1-公众号，2-小程序，3-公众号&小程序
				loading:false,
				total: 0,
				listQuery: {
					pageNum: 1,
					pageSize: 5,
					status:3
				},
				data: [],
				column: [{
						label: "名称",
						prop: "appname"
					},
					{
						label: "appId",
						prop: "appid",
						slotScope: true,
					},
					{
						label: "类型",
						prop: "type",
						render:(h,scope) => {
							return <span>{scope.row.type == 1 ? '公众号' : '小程序'}</span>
						}
					},
					{
						label: '状态',
						prop: 'status',
						render:(h,scope) => {
							return <span style={`color:${scope.row.status == 2 ? '#FF504D':''}`}>{messageHandleStatus[scope.row.status]}</span>
						}
					},
					{
						label: "消息处理模式",
						prop: "messageHandleType",
						width:120,
						render:(h,scope) => {
							return <span>{this.formatText(scope.row.messageHandleType)}</span>
						}
					},{
						label: "操作",
						prop: "action",
						slotScope: true,
						width: 200,
						align: "center",
						fixed:'right'
					}
				]
			}
		},
		methods: {
			getList(val){
				if(val){
					this.listQuery.pageNum = val.page;
				}
				this.$api.getWechatSystemLists({
					data:{
						status:this.listQuery.status
					},
					pageNum:this.listQuery.pageNum,
					pageSize:this.listQuery.pageSize
				}).then(res => {
					this.data = res.list;
					this.total = res.total
				})
			},
			onBasic(row){
				this.$refs.setBasic.openBasic(row)
			},
			onAdvanced(row){
				this.$refs.setAdvanced.openSetKeywords(row)
			},
			onBind(row){
				if(this.bindType == 1) {
					this.$api.getWechatSystemAuthUrl({
						authtype:row.type,
						 id: row.id
					}).then(res => {
						window.open(res.data,'_blank');
						this.$alert('是否已完成授权？', '提示', {
						  confirmButtonText: '确定',
						  showCancelButton:true,
						  showClose:false,
						  callback: action => {
							if(action == 'confirm'){
								this.getList()
							}
						  }
						});
					})
				}else{
					this.$refs.bindWechat.openBind(row)
				}
			},
			onBindAdd(row){
				if(this.bindType == 1) {
					this.$api.getWechatSystemAuthV2Url({
						authtype:row.type,
						id:1
					}).then(res => {
						window.open(res.data,'_blank');
						this.$alert('是否已完成授权？', '提示', {
						  confirmButtonText: '确定',
						  showCancelButton:true,
						  showClose:false,
						  callback: action => {
							if(action == 'confirm'){
								this.getList()
							}
						  }
						});
					})
				}else{
					this.$refs.bindWechat.openBind(row)
				}
			},
			onDetail(row){
				//1 开放平台 2 开发者
				if(row.appidConfig.accessMode == 2){
					this.$refs.bindWechat.openCopyBind(row)
				}else {
					this.$refs.openTypePlatform.onOpen(row)
				}
			},
			formatText(val){
				let result = [];
				if(val){
					 val.split(',').map(item => {
						 if(messageHandleTypeObj[item]){
							 result.push(messageHandleTypeObj[item][0])
						 }else {
							 result.push('--')
						 }
					})
					return result.join(',')
				}
				return '--'
			},
		},
		created() {
			this.getList();
		}
	}
</script>

<style lang="scss">
	.radio-wechat {
		padding: 10px 0;
		label {
			height: 22px;
		}
	}
	.wechat-system {
		font-size: 14px;

		h1 {
			color: #3C4353;
			font-size: 14px;
			margin-bottom: 16px;
		}

			&__card {
				>div {
					padding: 20px 30px;
					box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
					border-radius: 3px;
					border: 1px solid #DEDFDF;
					display: flex;
					align-items: center;
					position: relative;
					&:nth-of-type(2){
						margin-top: 30px;
					}
	
					.iconfont {
						font-size: 40px;
						color: #337EFF;
					}
	
					>div {
						display: inline-block;
						margin-left: 31px;
						vertical-align: middle;
						.more-text {
							display: flex;
							align-items: center;
						}
	
						h4 {
							color: #3C4353;
							font-weight: 500;
							margin-bottom: 16px;
						}
	
						p {
							color: #566980;
							font-size: 12px;
							line-height: 22px;
						}
	
						span {
							color: #000;
							font-weight: 700;
						}
						a {
							color: #337EFF;
							font-size: 12px;
						}
					}
	
					.el-button {
						position: absolute;
						right: 30px;
					}
				}
		}
		&__table {
			margin-top: 30px;
		}
	}
</style>
